<div class="modal-container">
  <h1 mat-dialog-title>Notificações</h1>
  <div mat-dialog-content class="notifications-content">
    <div
      class="notification"
      *ngFor="let notification of notifications.reverse()"
      (click)="navigateToDetails(notification.id)"
    >
      <div class="not-viewed" *ngIf="!notification.viewed"></div>

      <div>
        <strong class="notification-title">Nova denúncia</strong>

        <div class="notification-description">
          <p>A Nina recebeu um novo relato</p>
          <p>{{ notification.description }}</p>
        </div>

        <span>Há {{ convertToPtText(notification.date) }}</span>
      </div>
    </div>

    <strong *ngIf="notifications.length == 0">Nenhuma notificação</strong>
  </div>
</div>
